import axios from 'axios';
import { useQuery } from 'react-query';
import { environment } from '../config/environment';

export const fetchTx = (txid: string) =>
  axios
    .get(`${environment.apiBase}/tx/detail?txid=${txid}`)
    .then((res) => res.data);

export const useTx = (txid: string) => {
  return useQuery(['txdetail', '0x'+txid], () => fetchTx(txid), {
    retry: false,
    staleTime: 1000 * 60 * 60,
    refetchOnMount: false,
  });
};

export default useTx;